import { makeStyles, tokens } from "@fluentui/react-components";

export const useAppButtonStyles = makeStyles({
  root: {
    fontWeight: tokens.fontWeightSemibold,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: tokens.spacingHorizontalXS,
    border: "2px solid transparent",
    cursor: "pointer",
    textAlign: "center",
    transition: "all 0.2s ease"
  },

  /* Sizes */
  sm: {
    fontSize: "13px",
    fontWeight: "normal",
    padding: "0.4em 1.3em"
  },
  md: {
    fontSize: "18px",
    fontWeight: "600"
  },
  lg: {
    fontSize: "20px",
    fontWeight: "600",
    padding: "0.9em 2.5em"
  },

  /* Filled Buttons */
  brandFilled: {
    backgroundColor: "var(--ludvig-red) !important" as any,
    borderTopColor: "var(--ludvig-red) !important" as any,
    borderRightColor: "var(--ludvig-red) !important" as any,
    borderBottomColor: "var(--ludvig-red) !important" as any,
    borderLeftColor: "var(--ludvig-red) !important" as any,
    color: "#fff !important",

    "& .app-button-icon": {
      color: "#fff !important"
    },

    ":active": {
      backgroundColor: "var(--ludvig-red) !important" as any,
      borderTopColor: "var(--ludvig-red) !important" as any,
      borderRightColor: "var(--ludvig-red) !important" as any,
      borderBottomColor: "var(--ludvig-red) !important" as any,
      borderLeftColor: "var(--ludvig-red) !important" as any,
      color: "#fff !important",

      "& .app-button-icon": {
        color: "#fff !important"
      }
    },
    ":hover": {
      backgroundColor: "var(--ludvig-red-highlight) !important" as any,
      color: "#fff !important",

      "& .app-button-icon": {
        color: "#fff !important"
      }
    },
    ":disabled": {
      backgroundColor: "var(--ludvig-red-lightest) !important" as any,
      borderTopColor: "var(--ludvig-red-lightest) !important" as any,
      borderRightColor: "var(--ludvig-red-lightest) !important" as any,
      borderBottomColor: "var(--ludvig-red-lightest) !important" as any,
      borderLeftColor: "var(--ludvig-red-lightest) !important" as any,
      color: "#fff !important",
      cursor: "not-allowed",

      "& .app-button-icon": {
        color: "#fff !important"
      }
    },
    ":focus, :focus-visible": {
      backgroundColor: "var(--ludvig-red) !important" as any,
      borderTopColor: "var(--ludvig-red) !important" as any,
      borderRightColor: "var(--ludvig-red) !important" as any,
      borderBottomColor: "var(--ludvig-red) !important" as any,
      borderLeftColor: "var(--ludvig-red) !important" as any,
      color: "#fff !important",

      "& .app-button-icon": {
        color: "#fff !important"
      }
    }
  },

  /* Outline buttons */
  brandOutline: {
    backgroundColor: "#fff !important",
    color: "var(--ludvig-red) !important",
    border: "1px solid var(--ludvig-red) !important",
    borderTopColor: "var(--ludvig-red) !important" as any,
    borderRightColor: "var(--ludvig-red) !important" as any,
    borderBottomColor: "var(--ludvig-red) !important" as any,
    borderLeftColor: "var(--ludvig-red) !important" as any,

    "& .app-button-icon": {
      color: "var(--ludvig-red) !important"
    },

    ":active": {
      backgroundColor: "var(--ludvig-red-highlight) !important",
      color: "#fff !important",

      "& .app-button-icon": {
        color: "#fff !important"
      }
    },
    ":hover": {
      backgroundColor: "var(--ludvig-red) !important",
      color: "#fff !important",

      "& .app-button-icon": {
        color: "#fff !important"
      }
    },
    ":disabled": {
      color: "var(--text-light) !important",
      backgroundColor: "var(--ludvig-red-lightest) !important",
      border: "1px solid var(--ludvig-red-lightest) !important",
      cursor: "not-allowed",

      "& .app-button-icon": {
        color: "var(--text-light) !important"
      }
    },
    ":focus, :focus-visible": {
      backgroundColor: "#fff !important",
      color: "var(--ludvig-red) !important",
      border: "1px solid var(--ludvig-red) !important",

      "& .app-button-icon": {
        color: "var(--ludvig-red) !important"
      }
    }
  }
});
